import { sumDrinksForDay } from "./drinksPerDayOfWeek";
import { DrinkingDay } from "@dcc/types/drinkingDay";

export const drinksOnAverageDay = (day: DrinkingDay) => sumDrinksForDay(day);
